<div
  class="d-flex flex-column comment--bubble"
  [class.comment--bubble--left]="side() === 'left'"
  [class.comment--bubble--right]="side() === 'right'"
>
  <div class="bold flex-column text-opacity-75 disabled">
    <label for="author" class="mr--8">COMMENT by</label>
    <span id="author" CopyOnHover>{{ eventData().author }}</span>
  </div>
  <div>
    <div class="bold">
      <div class="text-wrap">
        {{ eventData().comment }}
      </div>
    </div>
  </div>

  <div class="mt-1">
    <span CopyOnHover>
      @if (eventData().timezone) {
        {{ eventData().timestamp | dayjs: 'L LT' }} ({{ eventData().timezone }})
      } @else {
        {{ eventData().timestamp | dayjs: 'L LT' : true }}
      }
    </span>
  </div>
</div>
